module.exports = __webpack_public_path__ + "img/tmkk-slide.24eca250.png";